import {
	findTranslatedSlugName,
	findTranslatedSlugNameFromLink,
	findTranslatedSlugPathFromLink,
} from "@babybjorn/utils/storyblok/translations";
import { getStoryblokLanguage } from "../../../config/storyblok-config";
import { getUrlFromStoryblokLink } from "./urls";

export const isImage = (filePath: string | undefined | null): boolean => {
	if (!filePath) {
		return false;
	}

	const imageExtensions = ["jpg", "jpeg", "png", "gif", "apng", "avif", "webp"]; //Add more if necessary
	const fileExtension = filePath.split(".").pop()?.toLowerCase();

	return !!fileExtension && imageExtensions.includes(fileExtension);
};

export const isVideo = (filePath?: string | null): boolean => {
	if (!filePath) {
		return false;
	}

	const videoExtensions = ["mp4", "ogg", "webm", "mov"]; //Add more if necessary
	const fileExtension = filePath.split(".").pop()?.toLowerCase();

	return !!fileExtension && videoExtensions.includes(fileExtension);
};

export const variantName = (color: string, fabric?: string): string => {
	return fabric ? `${color}, ${fabric}` : color;
};

export const findTranslatedSlugNameForSite = (
	page?: Parameters<typeof findTranslatedSlugName>[1],
) => findTranslatedSlugName(getStoryblokLanguage(), page);

export const findTranslatedSlugPathFromLinkForSite = (
	page?: Parameters<typeof findTranslatedSlugPathFromLink>[1],
) => findTranslatedSlugPathFromLink(getStoryblokLanguage(), page);

export const findTranslatedSlugNameFromLinkForSite = (
	page?: Parameters<typeof findTranslatedSlugNameFromLink>[1],
) => findTranslatedSlugNameFromLink(getStoryblokLanguage(), page);

export type StoryblokButtonProps = {
	link: string | null;
	label: string | null;
	icon?: string;
	target?: string;
	anchor?: string;
};

export const mapStoryblokButton = (
	buttonProps: {
		label: string | null;
		link?: Queries.LinkFragment | null;
		icon?: string | null;
	} | null,
): StoryblokButtonProps | null => {
	if (!buttonProps) return null;

	return {
		link: getUrlFromStoryblokLink(buttonProps.link),
		label: buttonProps.label,
		icon: buttonProps.icon ?? undefined,
		target: buttonProps.link?.target ?? undefined,
		anchor: buttonProps.link?.anchor ?? undefined,
	};
};
